import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MdPaginator, MdSort } from '@angular/material';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { AppMessage } from './../../Common/appMessage';
import { TableDataSource } from './../../Common/md-table';

declare var printJS;
@Component({
  selector: 'app-adm-manage-conflict-cases',
  templateUrl: './adm-manage-conflict-cases.component.html',
  styleUrls: ['./adm-manage-conflict-cases.component.css']
})
export class AdmManageConflictCasesComponent implements OnInit {
  @ViewChild(MdPaginator) paginator: MdPaginator;
  @ViewChild(MdSort) sort: MdSort;
  @Input('data') data: any;
  errorMsg: string;
  dataSource: TableDataSource | null;
  dataSubject: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]); // store all grid data
  conflictPaginationInfo: any = { totalRecords: 0 }; // Set initial value of Totalrecords property
  displayedColumns = ['examStartDateTime', 'candidateName', 'candidateContactNumber', 'candidateEmail', 'examCodeName', 'locationName', 'locationAddress'];
  public dateTimeFormat: string;
  public dateFormat:string;

  constructor(private _appMessage: AppMessage) {
  }

  ngOnInit() {
    this.setData();
  }

  setData() {
    this.dataSource = new TableDataSource(this.dataSubject, this.paginator, this.sort);
    this.errorMsg = this.data.message;
    this.dataSubject.next(this.data.response.results);
    this.conflictPaginationInfo = this.data.response.paginationInfo;
  }

  /**
   * Call printJS function of print-js file 
   * Pass JSON data and columns which are required in print.
   */
  onPrint() {

    let gridColumns = [
      'examStartDateTime',
      'candidateName', 'candidateContactNumber', 'candidateEmail', 'examCodeName', 'locationName', 'locationAddress'];
    printJS(
      {
        printable: this.data.response.results,
        properties: gridColumns,
        type: 'json',
        //gridHeaderStyle: 'color: red;  border: 2px solid #3971A5;',
        //gridStyle: 'border: 2px solid #3971A5;',
        header: 'Conflict Exams',
        documentTitle: 'Exception Calender'
      });
  }


}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-conflict-cases/adm-manage-conflict-cases.component.ts